import React from 'react';
import { Link } from "react-router-dom";
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { useEffect, useState } from 'react';
import { getLocations } from '../../../utils/platformConfig';
import { destinationPills } from '../../../data/destinationArtwork';
import { LOCATIONS as CODE_LOCATIONS } from '../../../data/locations';

import './styles.css'

/**
 * Destination pills, from `app_config/main.canonicalLocations` — the flat
 * canonical list the admin console keeps in step on every save.
 *
 * This used to be a module-level array pairing hardcoded names with pictures.
 * The names had to equal `listings.location` exactly, so it was a second copy
 * of the canonical list, and a rename in the console would have made every
 * listing in that destination undiscoverable from the homepage while the tile
 * carried on looking correct.
 *
 * Starts from the built-in list rather than empty: `getLocations()` falls back
 * to the compiled-in destinations, so a first paint with pills is honest, and
 * the homepage is never briefly blank on a slow connection.
 */
function useDestinations() {
  const [destinations, setDestinations] = useState(() => destinationPills(CODE_LOCATIONS));

  useEffect(() => {
    let live = true;
    getLocations().then((locations) => {
      if (live) setDestinations(destinationPills(locations));
    });
    return () => {
      live = false;
    };
  }, []);

  return destinations;
}

// Because this is an inframe, so the SSR mode doesn't not do well here.
// It will work on real devices.
const PopularDestinations = () => {
  const destinations = useDestinations();

  // Nothing to scroll through, and a bare heading over empty space reads as a
  // broken section. The fallback above makes this all but unreachable.
  if (!destinations.length) return null;

  return (
    <Box>
      <Typography sx={{margin: '.5rem 1rem', fontFamily: "Montserrat", fontWeight: "900", fontSize: "2.5rem" }} component="div" className='txt--gray' >
        Popular Destinations
      </Typography>
      <div className="popular-destinations">
        {destinations.map((destination, index) => (
          <Button
            key={`destinations-key-${index}`}
            component={Link}
            to={`/destination/${destination.link}`}
            state={destination}
            variant="outlined"
            className="destination-pill"
          >
            {destination.label}
          </Button>
        ))}
      </div>
    </Box>
  );
};


export default PopularDestinations;
